
/**
* @author Camilo
* @since  15/11/2017
**/
export class CrearUsuarioModel{

	constructor(
		public id:MchUsuariosId,
		public dfecultcambio:String, 
		public cnumid:string, 
		public vnombre:string, 
		public vapellido:string, 
		public cmail:string, 
		public cvlave:string, 
		public paramEstadosUsuario:ParamEstadosUsuario, 
		public bloquear:number,
		/*public paramRoles:ParamRoles, */
		public cip:string,
		public cambiar:number
		){}

}

export class ParamEstadosUsuario  {
	
	constructor(public nestado:number) {}
}

export class ParamRoles{

	constructor(public id:ParamRolesId){}
}


export class ParamRolesId{

	constructor(public nidrol:number, public ntipoempresa:number){}
}


export class MchUsuariosId{
	constructor(public cusuario:string, public nidrol:number, public ntipoempresa:number){}
}



// WEBPACK FOOTER //
// D:/REPO/FacturacionWeb/src/app/main/content/AdministracionUsuarios/CrearUsuario.model.ts